/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Contact\UserContact\UserContact.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Friday July 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Saturday, 3rd February 2024 02:04:02
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { useLang } from "Router/LangueProvider";
import Styles from "Content/Contact/UserForm/UserForm.module.css";
import { Form, Col } from "react-bootstrap";
import { forwardRef, useImperativeHandle, useState } from "react";
import { TextField } from "@mui/material";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "Content/Contact/UserForm/PhoneInput.css";
import { muiStyle } from "Theme/Mui";

type UserFormProps = {
    onUpdate: Function
};

const UserForm = forwardRef((props: UserFormProps, ref) => {
    const {translator} = useLang();
    const [lastName, setLastName] = useState<string>();
    const [firstName, setFirstName] = useState<string>();
    const [email, setEmail] = useState<string>();
    const [phone, setPhone] = useState<string | undefined>(undefined);
    const [cellPhone, setCellPhone] = useState<string | undefined>(undefined);

    useImperativeHandle(ref, () => {
        props.onUpdate();
        return {
            lastName,
            firstName,
            email,
            phone,
            cellPhone
        };
    }, [lastName, firstName, email, phone, cellPhone]);

    return (
        <div className={`${Styles.formHolder}`}>
            <h3 className="m-0">{translator.decode("dynamic.user")}</h3>
            <Form.Group className={`${Styles.formfield} ${Styles.bgColor}`} >
                <TextField required value={lastName ?? ""} sx={muiStyle} label={translator.decode("dynamic.lastname")} size="small" onChange={(e) => {setLastName(e.target.value)}} autoFocus/>
            </Form.Group>
            <Form.Group className={`${Styles.formfield} ${Styles.bgColor}`} >
                <TextField required value={firstName ?? ""} sx={muiStyle} label={translator.decode("dynamic.firstname")} size="small" onChange={(e) => {setFirstName(e.target.value)}}/>
            </Form.Group>
            <Form.Group className={`${Styles.formfield} ${Styles.bgColor}`} >
                <TextField inputProps={{type: "email"}} label={translator.decode("dynamic.email")} sx={muiStyle} size="small" required value={email ?? ""} onChange={(e) => {setEmail(e.target.value)}}/>
            </Form.Group>
            <Form.Group className={`${Styles.formfield}`} >
                <Form.Label className={`${Styles.fieldLabel}`}>
                    <p className="m-0">{translator.decode("dynamic.phone")} <span className={`${Styles.asterisk}`}>*</span></p>
                </Form.Label>
                <Col>
                    <PhoneInput required autoComplete="on" value={phone} onChange={setPhone} defaultCountry={"FR"} />
                </Col>
            </Form.Group>
            <Form.Group className={`${Styles.formfield}`} >
                <Form.Label className={`${Styles.fieldLabel}`}>
                    <p className="m-0">{translator.decode("dynamic.cellPhone")} <span className={`${Styles.asterisk}`}>*</span></p>
                </Form.Label>
                <Col>
                    <PhoneInput required autoComplete="on" value={cellPhone} onChange={setCellPhone} defaultCountry={"FR"} />
                </Col>
            </Form.Group>
        </div>
    );
});

export default UserForm;
